import React, { useCallback, useEffect, useMemo } from "react";
import ScreenCard from "../ScreenCard";
import { CreateMissionScreensContext } from "../../contexts/CreateMissionManager";
import { useI18n } from "../../hooks/i18n-hooks";
import { newMissionState } from "../../atoms/core";
import { useRecoilState } from "recoil";
import { FeeType, MissionFee } from "../../__generated__/graphql";
import MissionHotellerieRestaurantFees from "../../components/editors/MissionHotellerieRestaurantFees";
import { Buildable } from "ts-essentials";
import { Bubble } from "../../components/Bubble";
import { useBubbleStepOrigin } from "../../hooks/use-bubble-step-origin";

const CreateMissionHotellerieRestaurantFees = () => {
    const i18n = useI18n();
    const [isValid, setIsValid] = React.useState(false);
    const [mission, setMission] = useRecoilState(newMissionState);
    const { validateScreen } = React.useContext(CreateMissionScreensContext);

    const cctFees = useMemo(() => {
        return (
            mission.currentContract?.fees?.filter((fee) => {
                return fee?.type === FeeType.Cct;
            }) || []
        );
    }, [mission.currentContract?.fees]);
    const setFees = useCallback(
        (fees: Buildable<MissionFee>[]) => {
            setMission((oldMission) => {
                const newFees =
                    oldMission.currentContract?.fees?.filter((fee) => {
                        return fee?.type !== FeeType.Cct;
                    }) || [];
                newFees.push(...fees);
                return {
                    ...oldMission,
                    currentContract: {
                        ...oldMission.currentContract,
                        fees: newFees,
                    },
                };
            });
        },
        [setMission],
    );

    useEffect(() => {
        setIsValid(cctFees !== undefined);
    }, [cctFees, setIsValid]);

    const validate = React.useCallback(() => {
        void validateScreen("CreateMissionHotellerieRestaurantFees");
    }, [validateScreen]);

    const origin = useBubbleStepOrigin("CreateMissionHotellerieRestaurantFees");

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.translate("next"),
                    onPress: validate,
                    isValid: isValid,
                },
            ]}
        >
            <Bubble
                title={i18n.t("screens.user.create_mission_hotellerieRestaurationFees.title")}
                origin={origin}
            >
                <MissionHotellerieRestaurantFees mission={mission} setFees={setFees} />
            </Bubble>
        </ScreenCard>
    );
};

export default CreateMissionHotellerieRestaurantFees;
